"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var utils_2 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../../molecules/IconLink");

var PkMobile =
/** @class */
function (_super) {
  __extends(PkMobile, _super);

  function PkMobile(props) {
    var _this = _super.call(this, props) || this;

    _this.closeLoginInfo = function () {
      window.requestAnimationFrame(function () {
        return _this.setState({
          loginInfoOpen: false
        });
      });
      utils_2.WidgetEvents.removeBodyClose(_this.closeLoginInfo);
    };

    _this.state = {
      isSegmentOpen: false,
      loginInfoOpen: false
    };
    return _this;
  }

  PkMobile.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        isSegmentOpen = _a.isSegmentOpen,
        loginInfoOpen = _a.loginInfoOpen;
    var _b = this.props,
        children = _b.children,
        className = _b.className,
        isMenuRoot = _b.isMenuRoot,
        onBackClick = _b.onBackClick,
        mobileQuickLinks = _b.mobileQuickLinks,
        openRootItem = _b.openRootItem,
        segmentTree = _b.segmentTree,
        activeSegment = _b.activeSegment,
        metaTree = _b.metaTree,
        contentIncludesData = _b.contentIncludesData,
        applicationData = _b.applicationData,
        resourceBundleData = _b.resourceBundleData;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "pkmobile", className])
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header"
    }, isMenuRoot ? React.createElement("a", {
      onClick: function onClick() {
        return _this.setState(function (oldState) {
          return {
            isSegmentOpen: !oldState.isSegmentOpen
          };
        });
      },
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-icon", CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-sparten-toggle", isSegmentOpen && "open"])
    }, React.createElement(Icon_1.Icon, {
      name: "legacy_simple_arrow_down"
    })) : React.createElement("a", {
      onClick: onBackClick,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-icon", CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-back-button"])
    }, React.createElement(Icon_1.Icon, {
      name: "legacy_arrow_left"
    })), React.createElement("h2", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-headline"
    }, openRootItem.text), React.createElement("a", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-icon", CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-home-button"]),
      href: contentIncludesData.logoDataUrl.url,
      title: contentIncludesData.logoDataUrl.title
    }, React.createElement(Icon_1.Icon, {
      name: "legacy_home",
      color: Icon_1.Icon.Colors.DEFAULT
    }))), React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-segment", isSegmentOpen && CSSPrefix_1.lsgPre + "header-legacy-segment__open"])
    }, React.createElement("ul", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-segment-branch"])
    }, segmentTree.filter(function (item) {
      return !item.noMobile;
    }).map(function (segment) {
      return React.createElement("li", {
        className: segment.targetValue === activeSegment ? "active" : undefined
      }, React.createElement("a", {
        href: segment.href,
        onClick: segment.onClick,
        target: segment.target,
        className: "b-01"
      }, segment.label));
    })), React.createElement("ul", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-segment-meta"])
    }, metaTree.filter(function (item) {
      return !item.noMobile;
    }).map(function (meta) {
      return React.createElement("li", null, React.createElement("a", {
        href: meta.href,
        onClick: meta.onClick,
        target: meta.target
      }, meta.label));
    }))), children, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-login"
    }, !applicationData.loginStatus && React.createElement("a", {
      className: "b-a-04",
      title: resourceBundleData.link_login_tooltip,
      href: applicationData.headerLoginURL
    }, React.createElement(Icon_1.Icon, {
      name: "legacy_lock"
    }), resourceBundleData.link_login_label), applicationData.loginStatus && React.createElement(React.Fragment, null, React.createElement("a", {
      className: "b-a-05",
      title: resourceBundleData.link_logout_tooltip,
      href: "/lp/logout"
    }, resourceBundleData.link_logout_label), React.createElement("ul", {
      className: "mod mod-NavUser"
    }, React.createElement("li", null, React.createElement("a", {
      href: "#loginStatus",
      className: "item item-loginStatus info-box-below",
      title: resourceBundleData.text_logindata,
      onClick: function onClick(e) {
        _this.setState(function (prevState) {
          return {
            loginInfoOpen: prevState.loginInfoOpen === false
          };
        });

        e.preventDefault();
      }
    }, React.createElement(Icon_1.Icon, {
      name: "i_695"
    }))), React.createElement("li", null, applicationData.loginStatus === "FULL_LOGIN" && !!applicationData.postBoxCount && React.createElement("a", {
      id: "postBoxLink",
      href: resourceBundleData.link_postbox_url,
      className: "item item-messages u-color-primary",
      title: resourceBundleData.text_postbox_a_msg
    }, React.createElement(Icon_1.Icon, {
      name: "i_620"
    })), applicationData.loginStatus === "FULL_LOGIN" && !applicationData.postBoxCount && React.createElement("a", {
      id: "postBoxLink",
      href: resourceBundleData.link_postbox_url,
      className: "item item-messages",
      title: resourceBundleData.link_postbox_tooltip
    }, React.createElement(Icon_1.Icon, {
      name: "i_620"
    })))))), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-quicklinks"
    }, mobileQuickLinks.map(function (mobileQuicklink) {
      return React.createElement("a", {
        className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-quicklinks-link",
        href: mobileQuicklink.href,
        onClick: mobileQuicklink.onClick,
        target: mobileQuicklink.target
      }, mobileQuicklink.label);
    })), loginInfoOpen && React.createElement("div", {
      className: "info-box-msg posBelow",
      id: "loginStatus",
      ref: function ref(r) {
        utils_2.WidgetEvents.removeBodyClose(_this.closeLoginInfo);
        if (r) utils_2.WidgetEvents.addBodyClose(r, _this.closeLoginInfo);
      }
    }, React.createElement("table", null, React.createElement("tr", null, React.createElement("th", {
      colSpan: 2
    }, React.createElement("h1", {
      className: "h-03"
    }, resourceBundleData.text_logindata))), React.createElement("tr", null, React.createElement("td", null, resourceBundleData.settings_flyout_participant), React.createElement("td", null, applicationData.firstName, " ", applicationData.lastName)), React.createElement("tr", null, React.createElement("td", null, resourceBundleData.settings_flyout_userId), React.createElement("td", null, applicationData.userId)), React.createElement("tr", null, React.createElement("td", null, resourceBundleData.settings_flyout_lastLogin), React.createElement("td", null, applicationData.lastLogin))), React.createElement(IconLink_1.IconLink, {
      className: "close",
      iconName: Icon_1.Icon.Names.symbols___error,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.closeLoginInfo
    }, "x")));
  };

  return PkMobile;
}(React.Component);

exports.PkMobile = PkMobile;